import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import DownloadIcon from '@8x8/oxygen-icon/novo/DownloadIcon'

import { getIsElectron, getIsMobileSummaryPage } from '~/selectors/app'
import { downloadFile } from '~/core/utils'

const SlideshowActions = ({ screenshot }) => {
  const isMobileSummary = useSelector(getIsMobileSummaryPage)
  const isElectron = useSelector(getIsElectron)

  const download = useCallback(() => {
    downloadFile({ url: screenshot.link, isElectron })
  }, [screenshot])

  return (
    <>
      {!isMobileSummary && (
        <DownloadIcon
          data-test-id='slide-download-button'
          onClick={download}
        />
      )}
    </>
  )
}

export default SlideshowActions
